import { render, staticRenderFns } from "./_cms_page_alias.vue?vue&type=template&id=4f120740&"
import script from "./_cms_page_alias.vue?vue&type=script&lang=js&"
export * from "./_cms_page_alias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports